import {sendDeleteRequest, sendPostRequest, sendGetRequest} from '../requests';
import {AvailablePatient, NewSurveyFormSendData} from '../../components/surveys/types';

const baseUrl = '/surveys';

export const addSurvey =
  (survey: NewSurveyFormSendData): Promise<AvailablePatient[]> => {
    return sendPostRequest(baseUrl, survey);
  };

export const removeSurvey =
  (id: string): Promise<unknown> => {
    return sendDeleteRequest(`${baseUrl}/${id}`);
  };

export const getSurveysByPatientId = (id: number) => {
  return sendGetRequest(`${baseUrl}/patients/${id}`);
};

export const completePatientSurvey = (id: string, body) =>
  sendPostRequest(`${baseUrl}/${id}/complete`, body);
